// extracted by mini-css-extract-plugin
export default {"section":"vgNHL","inner":"jQt8a","item":"LsLnp","label":"ennZj","value":"vWxRE","fileAccess":"ILANK","action":"tX4Ah"};